import { useState, useRef } from 'react';
import { useFocusModuleInspector } from './useFocusModuleInspector';
export const useDynamicTheme = () => {
    const [activeSection, setActiveSection] = useState(null);
    const sectionMap = useRef(new Map());
    const registerSection = (node, metadata) => {
        if (node && !sectionMap.current.has(node)) {
            sectionMap.current.set(node, metadata);
            if (!activeSection && sectionMap.current.size === 1) {
                setActiveSection(metadata);
            }
        }
    };
    const handleActiveSectionChange = (activeNode) => {
        const metadata = sectionMap.current.get(activeNode);
        if (metadata) {
            setActiveSection(metadata);
        }
    };
    useFocusModuleInspector({
        refs: Array.from(sectionMap.current.keys()),
        onFocusModuleChange: handleActiveSectionChange,
    });
    return {
        registerSection,
        activeSection,
    };
};
